export default __webpack_public_path__ + "static/media/wegovy-inject-allsteps-waist.4e770478.mp4";